import * as React from 'react';
import classnames from 'classnames';
import Button from '@media-ui/core/src/components/Button';
import Text from '@media-ui/core/src/components/Text';
import Box from '@media-ui/core/src/components/Box';
import * as s from './Products.css';
import * as T from './Products.types';
const getClassnamesDependsOnArrayLength = (length: number) => {
    switch (length) {
        case 1:
            return s.oneProduct;
        case 2:
            return s.twoProducts;
        case 3:
            return s.threeProducts;
        case 4:
            return s.fourProducts;
    }
};
export const Products: React.FunctionComponent<T.IArticleProductsProps> = (props) => {
    const { items, titleBlock, textButton } = props;
    return (<div className={s.productsWrapper}>
      <Box noPadding classNameHeader={s.header} header={titleBlock} content={<div className={s.container}>
            {items.map((item, index, array) => (<div className={classnames(s.product, getClassnamesDependsOnArrayLength(array.length))} key={`article-product-item-${index}`}>
                <div className={s.wrapper}>
                  <Text className={s.title} type="paragraph">
                    {item.title}
                  </Text>
                  {item.short_description && (<Text className={s.description}>
                      {item.short_description}
                    </Text>)}
                  <div className={s.saleBlock}>
                    {item.price && (<Text className={s.price}>{item.price} ₽</Text>)}
                    <Button.Link target="_blank" href={item.purchase_link} theme="primary" className={s.button}>
                      {textButton || 'Купить'}
                    </Button.Link>
                  </div>
                </div>
                <div className={s.imgWrapper}>
                  <img src={item.image} alt="Фото товара"/>
                </div>
              </div>))}
          </div>}/>
    </div>);
};
